<div
  class="fz-tournament-controls__actions"
  [ngClass]="{
    'life-experience': isLifeExperience,
    'cash-page': !isLifeExperience && isEventPage
  }"
>
  <!-- join -->
  <button
    *ngIf="showJoinButton"
    mat-flat-button
    class="animation__glow fz-button--small"
    color="primary"
    data-ga-value="join-button"
    (click)="onJoin()"
  >
    <div>Join</div>
  </button>

  <!-- play -->
  <div
    [matTooltip]="
      !isCompleted && isFinished
        ? 'The tournament is not completed yet but it\'s expired since ' +
          (endTime | fzDateFormat | async)
        : isCompleted
          ? 'The tournament is completed.'
          : 'Click to play the tournament'
    "
    matTooltipClass="info-tooltip"
    aria-label="A button that plays the tournament"
    *ngIf="showPlayButton && !isComingSoon"
  >
    <button
      mat-flat-button
      color="primary"
      (click)="onPlay()"
      data-ga-value="play-button"
      [disabled]="isRetired || isFinished || isCompleted || !enabledPlayButton"
      [ngClass]="{
        'mat-button-loading': playButtonLoading === false
      }"
      class="play fz-button--small animation__glow"
    >
      <div *ngIf="!isRetired && !isCompleted && !userPass">
        {{ playText ? playText : 'Play' }} -
        <fz-currency [value]="entryAmount"></fz-currency>
      </div>
      <div *ngIf="isRetired">Retired</div>
      <div *ngIf="isCompleted">Completed</div>
      <div *ngIf="!isRetired && !isCompleted && userPass">
        <span *ngIf="userPass.entries < UNLIMITED_PASSES"
          >{{ playText ? playText : 'Play' }} - Pass {{ remainPassCount }}</span
        >
        <span *ngIf="userPass.entries >= UNLIMITED_PASSES"
          >{{ playText ? playText : 'Play' }} - Unlimited</span
        >
      </div>
    </button>
  </div>

  <fz-subscribe-button
    *ngIf="showPlayButton && isComingSoon"
    [currentUser]="user"
    [eventSchedule]="eventScheduler"
    [eventPrototypeUuid]="
      tournament ? tournament.uuid : tournamentDetails?.eventPrototypeUuid
    "
    [responsive]="responsive"
  ></fz-subscribe-button>

  <!-- Play another -->
  <button
    *ngIf="showPlayButtonAnother"
    mat-flat-button
    (click)="onPlayAnother()"
    class="play-another-tournament-button fz-button--small animation__glow"
    data-ga-value="tournament-control-play-another"
    [ngClass]="{ 'game-over-cash': isGameOverPage && !isLifeExperience }"
  >
    Play another tournament
  </button>

  <!-- share -->
  <button
    matTooltip="Share tournament"
    *ngIf="showShareButton"
    class="share fz-button--small"
    mat-stroked-button
    color="primary"
    (click)="onShare()"
  >
    <div
      class="share-text"
      [ngClass]="{
        'game-over-lept': isGameOverPage && isLifeExperience,
        'game-over-cash': isGameOverPage && !isLifeExperience
      }"
    >
      <mat-icon data-ga-value="tournament-control-share">share</mat-icon>
      <span>Share</span>
    </div>
  </button>

  <!-- try for free -->
  <button
    *ngIf="showTryForFreeButton && !isLifeExperience"
    mat-stroked-button
    color="primary"
    class="fz-button--small try-free"
    (click)="onTryForFree()"
    data-ga-value="tournament-control-try-free"
  >
    Try For Free
  </button>

  <button
    *ngIf="user?.membershipInfo?.type === 'MEMBER' && showBecomeZboButton"
    mat-stroked-button
    color="primary"
    class="become-zbo-button fz-button--small animation__glow"
    data-ga-value="tournament-control-become-zbo"
    (click)="becomeZBO()"
  >
    Become ZBO
  </button>
</div>
